/**
 * @file Motion trails (GDD §Fase 4 — pulido).
 *
 * Distance-based emission, so the spacing of the trail stays constant across
 * speed changes. It never touches the particle system
 * directly: it publishes `fx:burst` and lets whatever draws particles pick it
 * up, which keeps the two systems independent.
 */

import * as THREE from 'three';
import { System } from '../ecs/System.js';
import { Trail, Transform } from '../components/index.js';
import { Events } from '../core/EventBus.js';

export class TrailSystem extends System {
  static priority = 92;

  constructor() {
    super();
    /** @type {THREE.Vector3} @private */
    this._position = new THREE.Vector3();
    /** @type {THREE.Vector3} Emission axis: straight down, so puffs settle. @private */
    this._direction = new THREE.Vector3(0, -0.2, 0);
    /** @type {object} @private */
    this._burst = {
      position: this._position,
      direction: this._direction,
      count: 1,
      options: {
        speed: [0.4, 1.4],
        spread: 0.35,
        life: [0.2, 0.4],
        size: [0.1, 0.24],
        color: 0xffffff
      }
    };
  }

  /**
   * @param {number} _dt Delta time in seconds.
   * @returns {void}
   */
  update(_dt) {
    for (const entity of this.world.query(Trail, Transform)) {
      const trail = entity.get(Trail);
      const transform = entity.get(Transform);

      trail.travelled += transform.position.distanceTo(transform.previousPosition);
      if (trail.travelled < trail.distance) continue;
      trail.travelled = 0;

      this._position.copy(transform.position);
      this._position.y += 0.35;

      const options = this._burst.options;
      options.color = trail.color;
      options.size[0] = trail.size * 0.5;
      options.size[1] = trail.size;
      options.life[0] = trail.life * 0.6;
      options.life[1] = trail.life;

      this.ctx.events.emit(Events.FX_BURST, this._burst);
    }
  }
}
